import React, { useEffect } from 'react'

const TreeD = () => {
  useEffect(() => {
    const data = localStorage.getItem('treeDUrl')

    if (!data) return

    const html = atob(data)

    const blob = new Blob([html], { type: 'text/html' })
    const url = URL.createObjectURL(blob)

    window.location.replace(url)
  }, [])

  return <div>Redirecting to 3D Secure...</div>
}

export default TreeD
